import React from 'react';
import { Spinner } from 'react-bootstrap';
import DataTable from '../../DataTable/datatable.component';
import { Nav } from 'react-bootstrap';
import CommonConfigPage from './CommonConfigPage';
import { useGetConfigurationDataProperties } from '../../../hooks/useConfigurationDataProperties';
import ConfigurationDataPropertyEditDialog from './Dialogs/ConfigurationDataPropertyEditDialog';

function ConfigurationDataPropertiesTable({ onRowClick, refresh }) {

    const { configurationDataProperties, loading } = useGetConfigurationDataProperties(refresh);

    const tableColumns = [
        {
            Header: 'Name',
            accessor: 'name',
            filter: 'fuzzyText',
            Cell: (props) => {
                return <Nav><Nav.Link onClick={() => { onRowClick(props.row.original); }}>{props.value}</Nav.Link></Nav>
            }
        },
        {
            Header: 'Description',
            accessor: 'description',
            filter: 'fuzzyText'
        }
    ];

    if (loading) {
        return (
            <div className="d-flex justify-content-center">
                <Spinner animation="border" />
            </div>
        );
    }

    return <DataTable id="ConfigurationDataProperties" tableColumns={tableColumns} tableData={configurationDataProperties} />
}

function ConfigurationDataPropertiesConfiguration() {
    const getNewBusinessUnit = () => {
        return { id: null, name: "" }
    };

    return (
        <CommonConfigPage
            title="Configuration Data Properties"
            table={(showEditDialog, refreshList) => <ConfigurationDataPropertiesTable onRowClick={showEditDialog} refresh={refreshList} />}
            dialog={(dialogData, setDialogData, showDialog, closeDialog) => <ConfigurationDataPropertyEditDialog dialogData={dialogData} setDialogData={setDialogData} showDialog={showDialog} closeDialog={closeDialog} />}
            getNewConfigObject={getNewBusinessUnit}
        />
    );
}

export default ConfigurationDataPropertiesConfiguration;